import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { intermediateContent } from '../../data/intermediateContent';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.xl};
  background-color: ${props => props.theme.colors.background};
  text-align: center;
`;

const ContentContainer = styled(motion.div)`
  max-width: 600px;
  width: 100%;
`;

const Icon = styled(motion.div)`
  width: 80px;
  height: 80px;
  margin: 0 auto ${props => props.theme.spacing.xl};
  color: ${props => props.theme.colors.secondary};
  font-size: 48px;
`;

const Title = styled.h2`
  font-size: ${props => props.theme.typography.fontSize.h2};
  color: ${props => props.theme.colors.textPrimary};
  margin-bottom: ${props => props.theme.spacing.lg};
`;

const Text = styled.p`
  font-size: ${props => props.theme.typography.fontSize.body};
  color: ${props => props.theme.colors.textSecondary};
  margin-bottom: ${props => props.theme.spacing.xl};
  line-height: 1.6;
`;

const ContinueButton = styled(motion.button)`
  background-color: ${props => props.theme.colors.primary};
  color: white;
  padding: ${props => props.theme.spacing.md} ${props => props.theme.spacing.xl};
  border-radius: ${props => props.theme.borderRadius.medium};
  font-size: ${props => props.theme.typography.fontSize.h4};
  font-weight: 600;
  box-shadow: ${props => props.theme.shadows.medium};
  transition: transform ${props => props.theme.transitions.default},
              background-color ${props => props.theme.transitions.default};

  &:hover {
    transform: translateY(-2px);
    background-color: ${props => props.theme.colors.secondary};
  }

  &:active {
    transform: translateY(0);
  }
`;

const IntermediateScreen = ({ screenId, onContinue }) => {
  const content = intermediateContent.find(item => item.id === screenId);

  return (
    <Container>
      <ContentContainer
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
      >
        <Icon
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring" }}
        >
          {content?.icon}
        </Icon>

        <Title>{content?.title}</Title>
        
        <Text>{content?.text}</Text>

        <ContinueButton
          onClick={() => onContinue(screenId)}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Weiter
        </ContinueButton>
      </ContentContainer>
    </Container>
  );
};

export default IntermediateScreen; 